import _ from 'lodash';
import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, withRouter } from 'react-router-dom';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledButtonDropdown,
} from 'reactstrap';

import {
  deleteTimeTrackingReason,
  getTimeTrackingReasonsList,
} from '../../../../app/store/actions/timeTrackingReasons';
import addNotification from '../../../../components/notification';
import Table from '../../../../components/table/Table';
import ROUTES from '../../../../config/routes';

class TimeTrackingReasonsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModalDelete: false,
      timeTrackingReasonUpdate: null,
    };

    this.defaultSorted = [
      {
        id: 'code',
        desc: false,
      },
    ];

    this.tableColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        minWidth: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <button
              type="button"
              className="btn btn-default btn-xs"
            >
              {I18n.t('BEE55' /* Ações */)}
            </button>
            <UncontrolledButtonDropdown>
              <DropdownToggle color="default" caret className="btn-xs" />
              <DropdownMenu>
                <DropdownItem onClick={
                  () => this.showTimeTrackingReasonDetail(rows.row)
                }
                >
                  {I18n.t('BEE56' /* Detalhes */)}
                </DropdownItem>
                <DropdownItem onClick={
                  () => this.showEditTimeTrackingReason(rows.row)
                }
                >
                  {I18n.t('BEE57' /* Editar */)}
                </DropdownItem>
                <DropdownItem onClick={
                  () => this.showCopyTimeTrackingReason(rows.row)
                }
                >
                  {I18n.t('BEE80' /* Copiar */)}
                </DropdownItem>
                <DropdownItem onClick={
                  () => this.showDeleteTimeTrackingReason(rows.row)
                }
                >
                  {I18n.t('BEE81' /* Eliminar */)}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        ),
      }, {
        Header: I18n.t('BEE82' /* Código */),
        accessor: 'code',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE277' /* Descrição */),
        accessor: 'name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
      },
    ];
  }

  componentDidMount() {
    this.maintainsState();
  }

  maintainsState = async () => {
    if (this.props.location.state && this.props.location.state.dice) {
      this.setState({
        page: this.props.location.state.dice.page,
        firstRun: true,
      });
      await this.getTimeTrackingReasons();
    } else {
      await this.getTimeTrackingReasons();
    }
  };

  setInitState = () => {
    this.setState({
      showModalDelete: false,
      timeTrackingReasonUpdate: null,
    });
  };

  getTimeTrackingReasons = async () => {
    await this.props.getTimeTrackingReasonsList();
  };

  deleteTimeTrackingReason = async (timeTrackingReason) => {
    const result = await this.props.deleteTimeTrackingReason(timeTrackingReason._original.id);

    this.setInitState();
    if (result) {
      addNotification(
        'success',
        I18n.t('BEE4269' /* Eliminar Motivo de Finalização do Apontamento */),
        I18n.t('BEE4270', { 0: timeTrackingReason.code } /* Motivo Finalização Apontamento eliminado com sucesso! */),
        'top-right',
      );
    }
    await this.getTimeTrackingReasons();
  };

  showTimeTrackingReasonDetail = (timeTrackingReason) => {
    this.props.history.push({
      pathname: ROUTES.TIME_TRACKING_REASON_DETAIL,
      state: {
        timeTrackingReason: timeTrackingReason._original,
      },
      dice: {
        page: this.state.page,
      },
    });
  };

  showEditTimeTrackingReason = (timeTrackingReason) => {
    this.props.history.push({
      pathname: ROUTES.TIME_TRACKING_REASON_EDIT,
      state: {
        timeTrackingReason: timeTrackingReason._original,
      },
      dice: {
        page: this.state.page,
      },
    });
  };

  showCopyTimeTrackingReason = (timeTrackingReason) => {
    this.props.history.push({
      pathname: ROUTES.TIME_TRACKING_REASON_COPY,
      state: {
        timeTrackingReason: timeTrackingReason._original,
      },
    });
  };

  showDeleteTimeTrackingReason = (timeTrackingReason) => {
    this.setState({ showModalDelete: true, timeTrackingReasonUpdate: timeTrackingReason });
  };

  render() {
    const { timeTrackingReasonUpdate, showModalDelete, page } = this.state;
    const { timeTrackingReasonsList = [] } = this.props;

    return (
      <div>
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE4274' /* Apontamentos */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE4271' /* Motivo de Finalização do Apontamento */)}</li>
          </ol>
        </div>
        <Table
          downloadCSV
          wikiHelp={ROUTES.TIME_TRACKING_REASON_HELP}
          headerTitle={I18n.t('BEE4271' /* Motivo de Finalização do Apontamento */)}
          actionButtons={(
            <div className="ml-auto">
              <Link to={ROUTES.TIME_TRACKING_REASON_CREATE} className="btn btn-success btn-sm btn-rounded pl-2 pr-3">
                <i className="fa fa-plus mr-1" />
                {' '}
                {I18n.t('BEE4272' /* Incluir motivo */)}
              </Link>
            </div>
          )}
          panelHeaderProps={{
            onClickReload: this.getTimeTrackingReasons,
          }}
          filterable
          data={timeTrackingReasonsList}
          columns={this.tableColumns}
          expander
          defaultPageSize={10}
          defaultSorted={this.defaultSorted}
          page={(page) || ((!this.state.firstRun
            && this.props.location.state && this.props.location.state.dice
            && this.props.location.state.dice.page) ? this.props.location.state.dice.page : page)}
          onPageChange={(pg) => ((pg >= 0) ? this.setState({ page: pg }) : this.setState({ page: 0 }))}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
        />
        {(showModalDelete
          && (
            <SweetAlert
              danger
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE100' /* Confirmar */)}
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE101' /* Você tem certeza? */)}
              onConfirm={() => this.deleteTimeTrackingReason(timeTrackingReasonUpdate)}
              onCancel={() => this.setInitState()}
            >
              {I18n.t('BEE4273', { 0: timeTrackingReasonUpdate.code } /* O motivo %{0} será eliminado! */)}
            </SweetAlert>
          )
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  timeTrackingReasonsList: state.timeTrackingReasons && state.timeTrackingReasons.timeTrackingReasonsList,
});

const mapDispatchToProps = (dispatch) => ({
  getTimeTrackingReasonsList: () => dispatch(getTimeTrackingReasonsList()),
  deleteTimeTrackingReason: (reasonId) => dispatch(deleteTimeTrackingReason(reasonId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TimeTrackingReasonsList));
